import { Component, Injector } from '@angular/core';
import { MatFormFieldControl } from '@angular/material';
import { AbstractSelectComponent } from '@mctic/ng-core';
import { Portaria } from '../../model';
import { trackById } from '../../utilities/track-by-fn';

@Component({
  selector: 'app-select-portaria',
  providers: [{provide: MatFormFieldControl, useExisting: PortariaSelectComponent}],
  template: `
    <mat-select
      [compareWith]="trackById"
      [formControl]="formControl"
      (selectionChange)="onSelectionChange($event)"
      style="text-align: right;"
    >
      <mat-option *ngIf="!noSelectionLabel"></mat-option>
      <mat-option [value]="getOptionValue(option)" *ngFor="let option of options">
      {{option.numero}} - {{option.data | date:'yyyy'}}

      </mat-option>
    </mat-select>
  `
})
export class PortariaSelectComponent extends AbstractSelectComponent<Portaria> {

  protected trackById = trackById;

  constructor(injector: Injector) {
    super(injector);
  }

}
